<template>
  <div class="notification is-danger is-light" v-if="this.hasError">
    <div  v-for="error in this.errors" v-bind:key="error.title">
      <p> {{ error.title }} </p>
      <div  v-for="message in error.messages" v-bind:key="message" class="cc-word-wrap">
        <p> {{ message }} </p>
      </div>
      <p>Please contact support@climacheck.com if the issue persists.</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ccError',
  data () {
    return {
      errors: []
    }
  },
  computed: {
    hasError: function () {
      return this.errors.length > 0
    }
  },
  mounted () {},
  methods: {
    newError: function (title, errors, initiatior) {
      this.errors.push({
        title: initiatior + ' - ' + title,
        messages: errors
      })
    },
    newResponseError: function (response, initiatior) {
      if (response.name === 'TypeError') {
        this.newError('JS Error', [response.stack], initiatior)
      } else if (response.url) {
        this.newError('Failed request: ' + response.url, [response.status + ': ' + response.statusText], initiatior)
      }
    }
  }
}
</script>
